export default __webpack_public_path__ + "static/media/img-3343.8523115c.jpeg";